module.exports = __webpack_public_path__ + "static/Gilroy-Extrabold-5a9a1fcfa5baaa34e2ed1c11b37a6e11.woff2";